import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationDailySeriesResponse, UpdateOrganizationDailySeriesParams } from './types';

export async function updateOrganizationDailySeries(
  organizationId: string,
  params: UpdateOrganizationDailySeriesParams
) {
  const url = `/web/studio/organizations/${organizationId}/daily-series`;

  const body: Record<string, unknown> = {};

  if (params.disabled !== undefined) body.disabled = params.disabled;
  if (params.type !== undefined) body.type = params.type;

  const response = await api.executePutRequest<ObjectResponse<OrganizationDailySeriesResponse>>(url, body);

  return response.data;
}
